import React, { useContext } from 'react';
import { ContactInput } from 'sr-types/lib/person/v1/graphql';
import ContactFieldInputs from '../../../common/components/contacts/ContactFieldInputs';
import { useGetPersonContactInfo } from '../../../common/components/person/person';
import { CONSTANTS_ID } from '../../../common/constants/constants';
import { FormContext } from '../../../common/form/FormContext';
import InlineFieldsEditor from '../../../common/form/widgets/InlineFieldsEditor';
import { useRepresentativeDefaults } from '../../../shortlists/hooks/useRepresentativeDefaults';
import { personBusinessContactsValidationRules } from '../../person';
import {
    BusinessContactsEditorProps,
    editPersonBusinessContacts,
    getAddedBusinessContactsIds,
    useDirectlyAddBusinessContact
} from '../detailsPageUtilities/personBusinessContacts';

export default ({
    personEditingDetails,
    onCloseEditor,
    directAddContact = false,
    setPersonData,
    setShowPersonEditor,
    initialState
}: BusinessContactsEditorProps) => {
    const { state } = useContext(FormContext);
    const { getContactInfo, contactInfoLoading } = useGetPersonContactInfo();
    const { directlyAddBusinessContact, isBusinessContactsSaving, loadingContactInfoDirectly } =
        useDirectlyAddBusinessContact();
    const { getRepresentativeFieldsFromSlimSearch } = useRepresentativeDefaults();

    const onAddBusinessContact = (contactState: ContactInput) => {
        directAddContact
            ? directlyAddBusinessContact(contactState, state?.businessContacts).finally(() => onCloseEditor())
            : editPersonBusinessContacts(
                  contactState,
                  personEditingDetails,
                  getContactInfo,
                  state?.businessContacts,
                  onCloseEditor
              );
    };

    return (
        <InlineFieldsEditor
            key={
                personEditingDetails?.personReference?.id || initialState?.personReference?.id || CONSTANTS_ID.createId
            }
            titleToken={`${personEditingDetails ? 'edit' : 'add'}.business.contact`}
            validationRules={personBusinessContactsValidationRules}
            inputFields={
                <ContactFieldInputs
                    filterById={getAddedBusinessContactsIds(state?.businessContacts, state?.identity?.id)}
                    setPersonData={setPersonData}
                    setShowPersonEditor={setShowPersonEditor}
                    showOrganization
                    getDefaultContactFieldsForPerson={getRepresentativeFieldsFromSlimSearch}
                />
            }
            onSave={onAddBusinessContact}
            onCancel={onCloseEditor}
            checkboxLabelToken="primary.hiring.contact"
            checkboxName="isPrimary"
            isSaving={contactInfoLoading || isBusinessContactsSaving || loadingContactInfoDirectly}
            initialState={personEditingDetails || initialState}
            saveButtonLabel={`${Object.keys(personEditingDetails || {}).length !== 0 ? 'common.update' : 'dialog.add'}`}
        />
    );
};
